import React from 'react';
import {
	SkeletonFilter,
	SkeletonHeading,
	ContentWrapper,
} from '@atlassian/jira-spa-apps-common/src/skeletons';
import UFOLoadHold from '@atlassian/ufo-load-hold';

export const Skeleton = () => (
	<UFOLoadHold name="project-versions-skeleton">
		{/* @ts-expect-error - TS2741 - Property 'marginRight' is missing in type '{ children: Element[]; }' but required in type 'Readonly<ThemedOuterStyledProps<ClassAttributes<HTMLDivElement> & HTMLAttributes<HTMLDivElement> & { marginRight: string | number; }, any>>'. */}
		<ContentWrapper>
			<SkeletonHeading />
			<SkeletonFilter avatar={false} />
		</ContentWrapper>
	</UFOLoadHold>
);
